import {Button} from "@heroui/button";
import {useHistory} from "react-router-dom";

export default function MailMarketing() {

    const history = useHistory()

    return (
        <div>
            <div className={'border rounded-md mt-6 overflow-hidden'}>
                <div className="p-6">
                    <div className="text-3xl font-bold text-slate-700">
                        Messaggi personalizzati e intelligenti con test A/B
                    </div>
                    <div className="text-slate-600 text-lg mt-4">
                        crea messaggi personalizzati e dinamici in base alla provenienza dell'ospite, la stagionalità e altri parametri rilevati dal nostro script.
                        Sfrutta questo strumento per aumentare la visualizzazione delle tue tariffe e la conversione in fase d'acquisto.
                    </div>
                </div>
                <img src="/emailintro.png" alt=""/>
            </div>

            <div className="mt-6">
                <Button color="primary" onClick={() => history.push('/app/bedirect/email/create')}>Crea la tua email</Button>
            </div>
        </div>
    )

}
